import React from "react";

function formatRelative(date) {
	if (!date) return "";
	const d = typeof date === "number" ? new Date(date) : new Date(date);
	const diffMs = Date.now() - d.getTime();
	const min = Math.round(diffMs / 60000);
	if (min < 1) return "à l'instant";
	if (min < 60) return `il y a ${min} min`;
	const h = Math.round(min / 60);
	if (h < 24) return `il y a ${h} h`;
	const days = Math.round(h / 24);
	return `il y a ${days} j`;
}

export default function EditorFooter({
	onDelete,
	canDelete,
	onCancel,
	lastModifiedAt,
	saving,
	onSaveAsTemplate,
	onSave,
	canSave = true,
	mode,
}) {
	return (
		<footer className="editor-footer-bar">
			<div className="editor-footer-left">
				{onCancel && (
					<button className="editor-footer-btn" onClick={onCancel}>
						{/* « Fermer sans sauvegarder » se confondait avec « Quitter l'éditeur »
						    du rail, qui fait autre chose : sortir de l'éditeur. Ici on referme
						    la séance en restant dans l'éditeur. La confirmation en cas de
						    modification non enregistrée est inchangée. */}
						{mode === "create" ? "Annuler la création" : "Fermer la séance"}
					</button>
				)}
				{canDelete && (
					<button className="editor-footer-btn-danger" onClick={onDelete}>
						Supprimer
					</button>
				)}
			</div>

			<div className="editor-footer-status">
				{lastModifiedAt && `Modifié ${formatRelative(lastModifiedAt)}`}
			</div>

			<div className="editor-footer-right">
				{mode !== "editTemplate" && onSaveAsTemplate && (
					<button className="editor-footer-btn" onClick={onSaveAsTemplate} disabled={saving}>
						Enregistrer comme modèle
					</button>
				)}
				<button
					className="editor-footer-btn editor-footer-btn-primary"
					onClick={onSave}
					disabled={saving || !canSave}
				>
					{saving ? "Enregistrement…" : "Enregistrer"}
				</button>
			</div>
		</footer>
	);
}
